import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgC4 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "translate(2 27)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					stroke: "#0D0E10",
					strokeWidth: 2,
					x: -1,
					y: -1,
					width: 62,
					height: 28,
					rx: 2
				}),
				/* @__PURE__ */ _jsx("rect", {
					fill: "#1D1D1B",
					fillRule: "nonzero",
					x: 51,
					y: 2,
					width: 2,
					height: 22,
					rx: .9
				}),
				/* @__PURE__ */ _jsx("rect", {
					fill: "#1D1D1B",
					fillRule: "nonzero",
					x: 46,
					y: 2,
					width: 2,
					height: 22,
					rx: .9
				}),
				/* @__PURE__ */ _jsx("rect", {
					fill: "#1D1D1B",
					fillRule: "nonzero",
					x: 12,
					y: 2,
					width: 2,
					height: 22,
					rx: .9
				}),
				/* @__PURE__ */ _jsx("rect", {
					fill: "#1D1D1B",
					fillRule: "nonzero",
					x: 7,
					y: 2,
					width: 2,
					height: 22,
					rx: .9
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			d: "M24 36.12a7.47 7.47 0 001.26-.11 4.52 4.52 0 001.11-.36 3 3 0 00.85-.65 2 2 0 00.46-1h1.67v12.6H27.1v-8.9H24v-1.58zM39.61 46.861H31a5.15 5.15 0 01.75-2.74 7 7 0 012-2c.41-.3.84-.6 1.28-.88a8.9 8.9 0 001.23-.91 5 5 0 00.92-1.05 2.51 2.51 0 00.36-1.34 3.23 3.23 0 00-.09-.73 1.77 1.77 0 00-.31-.72 1.89 1.89 0 00-.65-.56 2.28 2.28 0 00-1.08-.23 2 2 0 00-1 .25 1.79 1.79 0 00-.65.66c-.169.314-.29.65-.36 1a7 7 0 00-.13 1.25h-2.04a6.36 6.36 0 01.31-1.94 4.41 4.41 0 01.81-1.54 4.06 4.06 0 011.36-1 5 5 0 013.83 0c.49.235.92.577 1.26 1 .31.365.538.79.67 1.25.132.418.2.853.2 1.29a4 4 0 01-.23 1.37 4.55 4.55 0 01-.67 1.09 6.75 6.75 0 01-.9 1c-.34.287-.673.557-1 .81l-1.08.72c-.36.23-.7.46-1 .69a5.11 5.11 0 00-.8.71 2 2 0 00-.47.78h6.14l-.05 1.77z",
			fill: "#1D1D1B",
			fillRule: "nonzero"
		})]
	})
});
export default SvgC4;
